import * as tslib_1 from "tslib";
import { DatePicker } from '@h3/antd-vue';
import { Component } from "vue-property-decorator";
import { TimeInputControl } from '../../controls';
let InputTimeRange = class InputTimeRange extends TimeInputControl {
    get begin() {
        if (this.ctrl.value && this.ctrl.value.length > 0) {
            return this.ctrl.value[0];
        }
    }
    get end() {
        if (this.ctrl.value && this.ctrl.value.length === 2) {
            return this.ctrl.value[1];
        }
    }
    get getFormat() {
        let displayFormat = this.control.options.displayFormat || '';
        switch (Number(displayFormat)) {
            case 7:
                return "HH:mm";
            case 8:
                return "HH:mm:ss";
            default:
                return "HH:mm:ss";
        }
    }
    onChangeStart(dates, dateStrings) {
        if (!this.ctrl.value || this.ctrl.value.length === 0) {
            this.ctrl.value = [dates];
        }
        else {
            this.ctrl.value.splice(0, 1, dates);
            this.ctrl.value = this.ctrl.value.slice();
        }
    }
    onChangeEnd(dates, dateStrings) {
        // this.ctrl.value[1] = dateStrings && dateStrings.length > 0 ? dateStrings : null;
        if (!this.ctrl.value || this.ctrl.value.length === 0) {
            this.ctrl.value = [null, dates];
        }
        else if (this.ctrl.value.length === 1) {
            this.ctrl.value.push(dates);
            this.ctrl.value = this.ctrl.value.slice();
        }
        else {
            this.ctrl.value.splice(1, 1, dates);
            this.ctrl.value = this.ctrl.value.slice();
        }
    }
};
InputTimeRange = tslib_1.__decorate([
    Component({
        name: "input-time-range",
        components: {
            ARangePicker: DatePicker.RangePicker
        }
    })
], InputTimeRange);
export default InputTimeRange;
